'use strict';

class salesLedgerService {
  constructor($http) {
    this.$http = $http;
  }

  get(number) {
    return this.$http.get(`/sales-ledger/${number}`);
  }

  getRecipient(number) {
    return this.$http.get(`/sales-ledger/?recipientNumber=${number}`);
  }

  getInvoiceBalance(number) {
    return this.$http.get(`/sales-ledger/invoices/${number}/balance`);
  }

  getInvoiceEntries(number) {
    return this.$http.get(`/sales-ledger/invoices/${number}`);
  }

  registerPayment(number, params) {
    return this.$http.post(`/invoices/${number}/payments`, params);
  }

  editPayment(number, params) {
    return this.$http.post(`/sales-ledger/${number}/edit`, params);
  }

  registerLoss(number, params) {
    return this.$http.post(`/sales-ledger/${number}/loss`, params);
  }

  refundPayment(number, params) {
    return this.$http.post(`/sales-ledger/${number}/refund`, params);
  }

  cancelPayment(number) {
    return this.$http.post(`/sales-ledger/${number}/cancel`);
  }

  download(params) {
    return this.$http.get(`/sales-ledger/`, {
      params: params,
      responseType: 'arraybuffer'
    }).then((resp) => {
      if (resp) {
        const filename = resp.headers()['content-disposition'] ? resp.headers()['content-disposition'].match(/filename="(.+)"/)[1] : 'rapport';
        const contentType = resp.headers()['content-type'];

        saveAs(new Blob([resp.data], {
          type: contentType
        }), filename);
      }
    });
  }
}

salesLedgerService.$inject = ['$http'];

angular
  .module('SendRegning')
  .service('salesLedgerService', salesLedgerService);
